module.exports = __webpack_public_path__ + "static/media/shanghai-7-cssAni.be705668.gif";